import styled from 'styled-components';

const StyledQueryBuilderWithPreviewHost = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
`;

const StyledQueryBuilderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  min-width: 0;
  min-height: 0;

  & [data-test='children-container'] {
    height: calc(100% - 140px);
    overflow: auto !important;
  }
`;

const StyledQueryBuilderHeader = styled.div`
  width: 100%;
  background-color: ${(props) => props.theme.colors.light};
  box-shadow: rgb(173, 173, 173) -2px 1px 4px;
  z-index: 9999;
  position: relative;
`;

const StyledQueryBuilderMain = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  background-color: ${(props) => props.theme.colors.light_dark};
  height: 100%;
  & > div {
    height: 100%;
  }
`;

const StyledQueryBuilderScroll = styled.div`
  flex: 1 1 0%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledDropBottom = styled.div`
  flex: 1 1 0%;
  min-height: 150px;
  border-top: 2px solid
    ${(props) =>
      props.entityDraggingEnter && !props.isEmpty
        ? props.theme.colors.secondary
        : 'transparent'};
  margin: 0 24px;
  position: relative;

  &:after {
    content: '';
    background-color: ${(props) =>
      props.entityDraggingEnter && !props.isEmpty
        ? props.theme.colors.secondary
        : 'transparent'};
    position: absolute;
    left: -2px;
    top: -4px;
    border-radius: 100%;
    height: 7px;
    width: 7px;
  }
`;

export {
  StyledQueryBuilderWithPreviewHost,
  StyledQueryBuilderWrapper,
  StyledQueryBuilderHeader,
  StyledQueryBuilderMain,
  StyledQueryBuilderScroll,
  StyledDropBottom,
};
